module.exports = __webpack_public_path__ + "assets/img/thumb-Kaplan-Professional-Pillar-Page-Resource.0f3e9277.jpg";